import React from 'react';

import * as ST from './styled';

interface IProps {
    url: string,
    text: string,
}

export const StepBlock: React.FC<IProps> = ({ url, text }) => {
    return (
        <ST.Container>
            <ST.Number url={url} data-test={'number'}/>
            <ST.Text data-test={'text'}>{text}</ST.Text>
        </ST.Container>
    );
};

export default StepBlock;


